import React from 'react'

export default function Loader() {
  return (
    <div style={{ height: "70vh", width: "100%" }} className="row d-flex align-content-center">
        <div className="col-12 d-flex justify-content-center">
        <div className="spinner-border text-primary" style={{ width: "5rem", height: "5rem" }} role="status"></div>
        </div>
    </div>
  )
}